import { Component, ContentChildren, QueryList, AfterContentInit, ChangeDetectionStrategy } from '@angular/core';
import { AccordionGroupComponent } from './accordion-group.component';


@Component({
  selector: 'accordion',
  template: `
    <ng-content></ng-content>
`,
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AccordionComponent  implements AfterContentInit {
  @ContentChildren(AccordionGroupComponent) 
  groups: QueryList<AccordionGroupComponent> | undefined;
  
  ngAfterContentInit() {
    
    // Set active to second element
    this.groups!.toArray()[1].opened = true;
    
    this.groups!.toArray().forEach((t) => {
      t.toggle.subscribe(() => {
        this.openGroup(t);
      });
    });
  }

  /**
   * Open an accordion group
   * @param group   Group instance
   */
  openGroup(group: any) {
    if(group.opened === true) {
        group.opened = false;
    } else {
        group.opened = true
    }
    
    // Use this if you want to have only one graop open at a time
    // this.groups!.toArray().forEach((t) => t.opened = false);
    // group.opened = true;
  }
}
